export enum OrderCallbackUrlStatus {
  InProgress = 'in_progress',
  Success = 'success',
  Error = 'error',
}
